/** Settings › This device › Desktop sync (desktop app only): whether sync is on, and the sync panel or its setup. */
import { Button, PlaceholderSettings, SettingsGroup, SettingsRow, useT, useWorkspace } from "@bundle/ui";
import { useEffect, useState } from "react";
import { desktopSync, type SyncState } from "../platform/desktopSync.ts";

export function DesktopSyncSettings() {
  const t = useT();
  const ws = useWorkspace();
  // undefined = loading; null = this build has no sync engine.
  const [state, setState] = useState<SyncState | null>();
  useEffect(() => {
    const sync = desktopSync(false);
    let alive = true;
    let unlisten: (() => void) | undefined;
    sync.status().then(
      (s) => alive && setState(s.state),
      () => alive && setState(null),
    );
    void sync.onStatus((s) => alive && setState(s.state)).then((u) => {
      if (alive) unlisten = u;
      else u();
    });
    return () => {
      alive = false;
      unlisten?.();
    };
  }, []);
  if (state === undefined) return null;
  if (state === null) return <PlaceholderSettings icon="cloud" title={t("settings.section.sync")} body={t("settings.sync.unavailable")} testID="sync-settings" />;
  const on = state !== "off";
  const sync = desktopSync(false);
  return (
    <SettingsGroup title={t("settings.section.sync")} testID="sync-settings">
      <SettingsRow
        label={on ? t("settings.sync.on") : t("settings.sync.off")}
        sub={t("settings.sync.body")}
        testID="sync-status"
        trailing={<Button label={on ? t("sync.files.entryOn") : t("sync.files.entry")} variant={on ? "secondary" : "primary"} size="sm" icon="cloud" onPress={() => void (on ? sync.openPanel() : sync.openSetup(ws.slug))} testID="sync-open" />}
      />
    </SettingsGroup>
  );
}
